import { createReducer } from "@reduxjs/toolkit";
import { login, loginFailure, loginSuccessful } from "./auth.actions";
import initialState from "./auth.store";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(login, (state) => {
        state.isAuthenticated = false;
        state.authError = null;
        state.authenticating = true;
    })
        .addCase(loginFailure, (state, { payload }) => {
        state.isAuthenticated = false;
        state.authError = payload;
        state.authenticating = false;
    })
        .addCase(loginSuccessful, (state, { payload }) => {
        state.isAuthenticated = true;
        state.authError = null;
        state.authenticating = false;
        state.user = payload;
    });
});
